import { render } from "./sipNumber.vue?vue&type=template&id=67fd30ed&scoped=true"
import script from "./sipNumber.vue?vue&type=script&lang=js"
export * from "./sipNumber.vue?vue&type=script&lang=js"

import "./sipNumber.vue?vue&type=style&index=0&id=67fd30ed&scoped=true&lang=css"
import "./sipNumber.vue?vue&type=style&index=1&id=67fd30ed&lang=css"
script.render = render
script.__scopeId = "data-v-67fd30ed"

export default script